import React from "react"
import { styled } from "@mui/material/styles"
import { Link as RouterLink } from "react-router-dom"
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Link,
  Box,
} from "@mui/material"
import { withRouter } from "react-router"

import TopLinkCardLink from "atoms/button/TopLinkCardLink"
import TopLinkCardDetail from "atoms/button/TopLinkCardDetail"
import TopLinkCardArrow from "atoms/button/TopLinkCardArrow"

// styled components
const TopLinkCards = styled(Card)({
  height: "100%",
})

const TopLinkCardActionArea = styled(CardActionArea)({
  height: "100%",
  "&:hover": {
    height: "100%",
    textDecoration: "none",
  },
})

const TopLinkCardMedia = styled(CardMedia)({
  height: "173px",
})

const TopLinkCardContent = styled(CardContent)({
  display: "flex",
  flexDirection: "column",
  height: "calc(100% - 173px)",
  padding: "18px",
})

const TopLinkCardDetailBox = styled(Box)({
  flexGrow: "1",
  margin: "0 0 20px",
})

const LinkBox = styled(Box)({
  display: "block",
  textAlign: "right",
})

export const TopLinkCard = ({
  detail,
  image,
  link,
  isRouter,
  linkText,
  dataGa,
}) => {
  const linkData = isRouter
    ? { to: link, component: RouterLink }
    : {
        component: Link,
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
      }
  return (
    <TopLinkCards data-ga={dataGa}>
      <TopLinkCardActionArea {...linkData}>
        <TopLinkCardMedia image={image} />
        <TopLinkCardContent>
          <TopLinkCardDetailBox id={dataGa + "Detail"}>
            <TopLinkCardDetail detail={detail} />
          </TopLinkCardDetailBox>
          <LinkBox id={dataGa + "LinkText"}>
            <TopLinkCardLink>{linkText}</TopLinkCardLink>
            <TopLinkCardArrow />
          </LinkBox>
        </TopLinkCardContent>
      </TopLinkCardActionArea>
    </TopLinkCards>
  )
}

export default withRouter(TopLinkCard)
